<form [formGroup]="formName">
    @for (chip of chips; track chip;let i = $index) {
        <p-chip class="cursor-pointer" (click)="toggleSelection(chip)" [ngClass]="{'selected': chip.selected}">{{ chip.label }}</p-chip>
    }
    <input style="display: none;" type="text" pInputText [formControlName]="field?.isOneToMultiple ? field?.attributeCodeOneToMultiple : field.attributeCode" class="w-full"/>
</form>

